// ======================================================================

$(document).ready(function(){
  $('body').on('click', '.copy-btn', function(e) {
    var copyText = document.getElementById("discount_get");
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    document.execCommand("copy");
    //alert("Copied the text: " + copyText.value);
  })

  $('body').on('click', '.close-size-pop', function(e) {
    $(".product-size.custom-cart-variants").removeClass("activeSizes");

  })

  $('.header-cart-related-list').on('swipe', function(event, slick, direction) {
    $(".product-size.custom-cart-variants").removeClass("activeSizes");

  });
  $('body').on('click', '.header-cart-related-list .slick-next.slick-arrow', function(e) {
    $(".product-size.custom-cart-variants").removeClass("activeSizes");
    //$(".custom-cart-sizes-get").removeClass("active");

  })
  $('body').on('click', '.cart-select-size', function(e) {
    //alert("click");
    $(this).parents(".product-add-size-chrt-box").parents(".product-add-size-chrt-row").parents(".line-item-content").parents(".related-each-item").children(".custom-cart-variants").addClass("activeSizes");

  })
  $('body').on('click', '.product-add-con button', function(e) {
    e.preventDefault();
   
   
    var Variantsget = $(this).parents(".product-add-con").attr("data-idget");
    Variantsget = parseInt(Variantsget);
    //alert(Variantsget);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+ Variantsget,
      dataType: 'json',
      success: function(data){
        saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
        //alert("sucess");
        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',

          success: function(data) 
          {
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            var countget=$(data).find('.cart_count_items').html();
            $('.cart_count_items').html(countget);
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $('.header-cart-related-list').slick({
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1
            });
          }
        })
      }
    })	
  })
  $('body').on('click', '.custom-cart-sizes-get', function() {
    var valuereceive = $(this).attr("data-value");
    var varinstId = $(this).attr("data-variId");
    $(this).parents(".custom-cart-variants").next(".line-item-image").children(".line-item-cst-row").children(".line-item-cst-cont").children(".line-item-content").children(".product-add-size-chrt-row").children(".product-add-con").attr("data-idget",varinstId);
    $(this).parents(".custom-cart-variants").next(".line-item-image").children(".line-item-cst-row").children(".line-item-cst-cont").children(".line-item-content").children(".line-item-content-qty-price").children(".slect-size-custom").children(".size-changed").children("span").html(valuereceive);
    $(".product-size.custom-cart-variants").removeClass("activeSizes");
    //.next(".line-item-image").children(".line-item-cst-row").children(".line-item-cst-cont").children(".line-item-content").children(".line-item-content-qty-price").children(".product-add-size-chrt-box").children(".slect-size-custom").children(".size-changed").children("span").html(valuereceive);
    //    $(".product-size.custom-cart-variants").removeClass("activeSizes");
    //     //$(this).parents(".custom-cart-variants").parents(".product-add-size-chrt-row").prev(".line-item-content-qty-price").children(".slect-size-custom").children(".size-changed").children("span").html(valuereceive);
    //     $(this).parents(".custom-cart-variants").next(".cart-select-box").children("option").each(function(){
    //     var getoption =  $(this).val();
    //       if(valuereceive == getoption)
    //     {
    //       var avriantId = $(this).attr("data-val");
    //       alert(avriantId);
    //       //$(this).parents(".cart-select-box").parents(".product-add-size-chrt-box").next(".product-add-con").attr("data-idget",avriantId);
    //     }
    // })

  })
  $('body').on('click', '.custom-cart-icon-box, .custom-mobile-cart', function() {
    $("#overlay").addClass("is-active");
    $(".inline-cart").addClass("is-active");
	/* changes - toggle hidden reward & chat widget */
    $("#admin-bar-iframe").css("display", "none");
    $("#chat-button").css("display", "none");
  })
  $('body').on('click', '.qtyplus', function() {
    var elem = $(this).prev();
    var valuepluss = $(this).attr("max");
    var val_qty = parseInt($(this).prev(".qty").val());
    console.log(val_qty);

   
                      
    var getline = $(this).prev(".qty").attr("data-line-item-index");
    getline = parseInt(getline);
    if(val_qty >= 0 &&  val_qty < valuepluss)
      {
        val_qty = val_qty + 1 ;
        $(this).prev(".qty").val(val_qty);
                      if(val_qty == 0   )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_default').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_default').html());
                        $('.offer-container .offer-code').html('');
                      //  $('.offer-container .offer-price .current').html('$175');
                      //  $('.offer-container .offer-price .original').html('$1999.00');
                      
                       
                      }
                     if( val_qty == 1  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_1').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_1').html());
                        $('.offer-container .offer-code').html('');
                       // $('.offer-container .offer-price .current').html('$175');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                      if(val_qty == 2  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_2').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_2').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_2').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$175');
                        //$('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                       if(val_qty == 3  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_3').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_3').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_3').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$318');
                       // $('.offer-container .offer-price .original').html('$3200.00');
                       
                      }
    if(val_qty == 4  )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_4').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_4').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_4').html()+'</strong>');
                       // $('.offer-container .offer-price .current').html('$400');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                       
                      }
      }

    if(elem.attr("data-keys") != undefined) {
      qq = elem.attr("data-quantity").split(",");
			kk = elem.attr("data-keys").split(",");
							uu = {};
							for(var i = 0; i < kk.length; i++)
							{
								uu[kk[i]] = qq[i] * elem.val();
							}
              
							$.ajax({
								type: 'POST',
								url: '/cart/update.js',
								data: { updates: uu },
								dataType: 'json',
								success:function(data){
									if(data.item_count > 0){
                    $('.cart_count_items').html(data.item_count);          
        
                  } else {
                    $('.cart_count_items').html(data.item_count) ;         
                  }
        
                  $.ajax({
                    type: "GET",
                    url: "/cart",
                    dataType: 'html',
        
                    success: function(data) 
                    {
                      console.log("syncCart");
        
                      // console.log(data);
                      var minicartdata=$(data).filter('#slidingcartmain').html();
                      var countget=$(data).find('.cart_count_items').html();
                      $('.cart_count_items').html(countget);
                      // console.log(minicartdata);
                      $('#slidingcartmain').html(minicartdata);
                      $('.header-cart-related-list').slick({
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      });
                      $("#overlay").addClass("is-active");
                      $(".inline-cart").addClass("is-active");
                      /* changes - toggle hidden reward & chat widget */
                      $("#admin-bar-iframe").css("display", "none");
                      $("#chat-button").css("display", "none");
                      //console.log();
                       $('.discount-title.active').each(function () {
                         console.log('here');
    const $activeTitle = $(this);
    const $prevStep = $activeTitle.closest('.discount-step').prev('.discount-step');

    if ($prevStep.length) {
      $prevStep.find('.discount-title').addClass('remove-after');
    }
  });
                    }
                  })
								}
							});
    } else {
      var last_val = parseInt($(this).prev(".qty").val());
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=' + last_val + '&line=' + getline,
        dataType: 'json',

        success: function(data) 
        {
          if(data.item_count > 0){
            $('.cart_count_items').html(data.item_count);          

          } else {
            $('.cart_count_items').html(data.item_count) ;         
          }

          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: 'html',

            success: function(data) 
            {
              console.log("syncCart");

              // console.log(data);
              var minicartdata=$(data).filter('#slidingcartmain').html();
              var countget=$(data).find('.cart_count_items').html();
              $('.cart_count_items').html(countget);
              // console.log(minicartdata);
              $('#slidingcartmain').html(minicartdata);
            
              $('.header-cart-related-list').slick({
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
              });
              $("#overlay").addClass("is-active");
              $(".inline-cart").addClass("is-active");
              /* changes - toggle hidden reward & chat widget */
              $("#admin-bar-iframe").css("display", "none");
              $("#chat-button").css("display", "none");
              
            }
          })
        }
      })
    }
  });

  $('body').on('click', '.qtyminus', function() {
    var valueplus = $(this).attr("min");
    var elem = $(this).next();
    var val_qty = parseInt($(this).next(".qty").val());
    var getline = $(this).next(".qty").attr("data-line-item-index");
    getline = parseInt(getline);
    if(val_qty > 1)
    {
      val_qty = val_qty - 1 ;
      console.log(val_qty);
      $(this).next(".qty").val(val_qty);
      
                      if(val_qty == 0   )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_default').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_default').html());
                        $('.offer-container .offer-code').html('');
                      //  $('.offer-container .offer-price .current').html('$175');
                      //  $('.offer-container .offer-price .original').html('$1999.00');
                      
                       
                      }
                     if( val_qty == 1  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_1').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_1').html());
                        $('.offer-container .offer-code').html('');
                       // $('.offer-container .offer-price .current').html('$175');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                      if(val_qty == 2  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_2').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_2').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_2').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$175');
                        //$('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                       if(val_qty == 3  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_3').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_3').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_3').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$318');
                       // $('.offer-container .offer-price .original').html('$3200.00');
                       
                      }
    if(val_qty == 4  )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_4').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_4').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_4').html()+'</strong>');
                       // $('.offer-container .offer-price .current').html('$400');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                       
                      }
    } 

    if(elem.attr("data-keys") != undefined) {
      qq = elem.attr("data-quantity").split(",");
			kk = elem.attr("data-keys").split(",");
			uu = {};
							for(var i = 0; i < kk.length; i++)
							{
								uu[kk[i]] = qq[i] * elem.val();
							}
							$.ajax({
								type: 'POST',
								url: '/cart/update.js',
								data: { updates: uu },
								dataType: 'json',
								success:function(data){
									if(data.item_count > 0){
                    $('.site-header__cart #CartCount').html(data.item_count);          
                  } else {
                    $('.site-header__cart #CartCount').html(data.item_count) ;         
                  }
        
                  $.ajax({
                    type: "GET",
                    url: "/cart",
                    dataType: 'html',
                    success: function(data){
                      console.log(data);
                      // console.log(data);
                      var minicartdata=$(data).filter('#slidingcartmain').html();
                      var countget=$(data).find('.cart_count_items').html();
                      $('.cart_count_items').html(countget);
                      // console.log(minicartdata);
                      $('#slidingcartmain').html(minicartdata);
                      $('.header-cart-related-list').slick({
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      });
                      $("#overlay").addClass("is-active");
                      $(".inline-cart").addClass("is-active");
                      /* changes - toggle hidden reward & chat widget */
                      $("#admin-bar-iframe").css("display", "none");
                      $("#chat-button").css("display", "none");
                    }
                  })
								}
							});
    } else {
      var last_val = parseInt($(this).next(".qty").val());
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=' + last_val + '&line=' + getline,
        dataType: 'json',

        success: function(data) 
        {
          if(data.item_count > 0){
            $('.site-header__cart #CartCount').html(data.item_count);          

          } else {
            $('.site-header__cart #CartCount').html(data.item_count) ;         
          }

          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: 'html',
            success: function(data){
              console.log("syncCart");
              // console.log(data);
              var minicartdata=$(data).filter('#slidingcartmain').html();
              var countget=$(data).find('.cart_count_items').html();
              $('.cart_count_items').html(countget);
              // console.log(minicartdata);
              $('#slidingcartmain').html(minicartdata);
              $('.header-cart-related-list').slick({
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
              });
              $("#overlay").addClass("is-active");
              $(".inline-cart").addClass("is-active");
              /* changes - toggle hidden reward & chat widget */
              $("#admin-bar-iframe").css("display", "none");
              $("#chat-button").css("display", "none");
            }
          })
        }
      })
    }
  });


  $(".overlayimg").click(function(){
    $(".main-image").fadeOut();
    $(".overlayimg").fadeOut();
  });

  $(".crossdiv").click(function(){
    $(".main-image").fadeOut();
    $(".overlayimg").fadeOut();
  });

})

// Set the currency to a default based on a landing page
$(document).ready(function(){
  $('.size-select select').each(function() {
  $(this).trigger('change');
});
                   $(document).on('change', '.size-select select', function () {
  var $select = $(this);
  var selectedFormat = $select.val(); // 'us' or 'eu'
  var $wrapper = $select.closest('.size-select');

  // Check if it's the first interaction
  var lastFormat = $wrapper.data('current-format');

  // If first interaction or changed value, update
  if (!lastFormat || selectedFormat !== lastFormat) {
    $wrapper.find('.size').each(function () {
      var $btn = $(this);
      if (selectedFormat === 'us') {
        $btn.html($btn.attr('data-us'));
      } else {
        $btn.html($btn.attr('data-eu'));
      }
    });

    // Store the current format for future comparisons
    $wrapper.data('current-format', selectedFormat);
  }
});
 $(document).on('click','.size',function(){
     var elem = $(this);
                      elem.parent().find(".active").removeClass("active");
                      elem.addClass("active");
  });
  $(document).on('click', '.choose-btn', function(e){
    var size=$(this).closest('.add-on-card').find('.size-options .size.active').data('id');
    $('.no_brainer_size_error').hide();
    if(size != undefined)
    {
       $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+ size,
      dataType: 'json',
      success: function(data){
        saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
        //alert("sucess");
        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',

          success: function(data) 
          {
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            var countget=$(data).find('.cart_count_items').html();
            $('.cart_count_items').html(countget);
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $('.header-cart-related-list').slick({
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1
            });
          }
        })
      }
    });	
    }
    else
    {
      $(this).closest('.add-on-card').find('.no_brainer_size_error').show();
    }
  });
  
  /***************** Product Option Selection and Add to Cart ***********/
  $('body').on('click', '.btn.product-form__cart-submit', function(e){
 
     $(".qty_error-message").remove();
     var $thisbtn=$(this);
    var flag_val = false;
    e.preventDefault();
    var data_v =  $(".custom-product-info form.product-form .size-each").attr('data-value'); 
if (typeof data_v !== 'undefined' && data_v !== null && data_v !== '') {
    var size_active =  $(".size-each.active").length;  
} else {
    var size_active = 1;  
}
   // var size_active =  $(".custom-product-info form.product-form .size-each.active").length;  
        console.log('size_active', size_active);
  
    var sizeDivExists = $(".size-each").length;
     console.log('sizeDivExists', sizeDivExists);
    var size_error =  $("#size-error").length;   
      console.log('size_error', size_error);
    var buynow = $(this).hasClass("buynow");
    var this_obj = $(this);
  
    if(this_obj.hasClass('on-bundle')) {
      size_active = size_active/2;
    }
    if(sizeDivExists>0.5){
      if(size_active == '0'){
      $(".custom-product-info .product-form__for_floating-right .product-form__item.product-form__item--submit div#size-error").show();  
      }else{
          $(".custom-product-info .product-form__for_floating-right .product-form__item.product-form__item--submit div#size-error").hide();  
      }
    if(size_active>0.5 || size_error == 0)
    {

      console.log('88888888888888888888888888888888');
     
      if(this_obj.hasClass('on-bundle')) {
        /*
        var args = [];
        var args_temp = {};

        args_temp = {
            quantity: 1,
            id: $('#shoe-variant-id').html()
        };
        args.push(args_temp);

        args_temp = {
            quantity: 1,
            id: $('#bag-variant-id').html()
        };
        args.push(args_temp);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { items: args },
          dataType: 'json',
          success: function(response){
            saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                console.log("syncCart");
                // console.log(data);
                var countget=$(data).find('.cart_count_items').html();
                $('.cart_count_items').html(countget);
                var minicartdata=$(data).filter('#slidingcartmain').html();
                var countget=$(data).find('.cart_count_items').html();
                if(countget == 1){
                  $( ".custom-cart-icon-box" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                  $( ".custom-mobile-cart" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                }
                else{
                  $('.cart_count_items').html(countget);
                }
                if(buynow)
                {
                  location = "/checkout";
                }
                else
                {
                // console.log(minicartdata);
                $('#slidingcartmain').html(minicartdata);
                $("#size-error").hide();
                $('.header-cart-related-list').slick({
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                });
                $("#overlay").addClass("is-active");
                $(".inline-cart").addClass("is-active");
                /* changes - toggle hidden reward & chat widget
                $("#admin-bar-iframe").css("display", "none");
                $("#chat-button").css("display", "none");
                }
              }
            })
          }
        })
        */
      } else {
       
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:$(".product-form").serialize(),
          dataType: 'json',
          success: function(response){
            saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                console.log("syncCart");
                // console.log(data);
                var countget=$(data).find('.cart_count_items').html();
                 
                 var divLength =$(data).find('.cart_count_items').length;
                
                       
                $('.cart_count_items').html(countget);
                var minicartdata=$(data).filter('#slidingcartmain').html();
                var countget=$(data).find('.cart_count_items').html();
                //console.log('coun');
                //console.log(countget+1);
                if(countget == 0   )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_default').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_default').html());
                        $('.offer-container .offer-code').html('');
                      //  $('.offer-container .offer-price .current').html('$175');
                      //  $('.offer-container .offer-price .original').html('$1999.00');
                      
                       
                      }
                     if( countget == 1  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_1').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_1').html());
                        $('.offer-container .offer-code').html('');
                       // $('.offer-container .offer-price .current').html('$175');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                      if(countget == 2  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_2').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_2').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_2').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$175');
                        //$('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                       if(countget == 3  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_3').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_3').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_3').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$318');
                       // $('.offer-container .offer-price .original').html('$3200.00');
                       
                      }
    if(countget == 4  )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_4').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_4').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_4').html()+'</strong>');
                       // $('.offer-container .offer-price .current').html('$400');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                       
                      }
                if(countget == 1){
                  $( ".custom-cart-icon-box" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                  $( ".custom-mobile-cart" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                }
                else{
                  $('.cart_count_items').html(countget);
                }
                
               
                if(buynow)
                {
                  location = "/checkout";
                }
                else
                {
                // console.log(minicartdata);
                $('#slidingcartmain').html(minicartdata);
                $("#size-error").hide();
                $('.header-cart-related-list').slick({
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                });
                $("#overlay").addClass("is-active");
                $(".inline-cart").addClass("is-active");
                /* changes - toggle hidden reward & chat widget */
                $("#admin-bar-iframe").css("display", "none");
                $("#chat-button").css("display", "none");
                }
              }
            })
           },
            error: function(xhr, status, error) {
                // Handle error
              //Error: Insufficient stock. Please reduce the quantity.
                let errorMessage = $('<div class="qty_error-message">Out of stock.</div>');
                
                // Insert the error message before the button
                errorMessage.insertBefore($thisbtn);
                
                // Remove the error message after 5 seconds
                setTimeout(function() {
                     $(".qty_error-message").remove();
                }, 5000);
            }
        })
      }
    }
    else{
      console.log('999999999999999999999999999999999999999');
      if(this_obj.hasClass('on-bundle')) {
        /*
        let error_text = 'Please choose your ';
        if($('.shoe-collection-container').find('.size-each.active').length <= 0) {
          error_text += 'shoe';
        }
        if($('.shoe-collection-container').find('.size-each.active').length <= 0 && $('.bag-collection-container').find('.size-each.active').length <= 0) {
          error_text += ' and ';
        }
        if($('.bag-collection-container').find('.size-each.active').length <= 0) {
          error_text += 'bag';
        }
        $("#size-error p").html(error_text);
        $("#size-error").show();
        */
      } else {
        $("#size-error").show();
      }
    }
    }
    else{
        
      $.ajax({

        
          type: 'POST',
          url: '/cart/add.js',
          data:$(".product-form").serialize(),
          dataType: 'json',
          success: function(response){
            saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                console.log("syncCart");
                // console.log(data);
                var countget=$(data).find('.cart_count_items').html();
                $('.cart_count_items').html(countget);
                var minicartdata=$(data).filter('#slidingcartmain').html();
                var countget=$(data).find('.cart_count_items').html();
                if(countget == 1){
                  $( ".custom-cart-icon-box" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                  $( ".custom-mobile-cart" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                }
                else{
                  $('.cart_count_items').html(countget);
                }
                 var divLength =$(data).find('.cart_count_items').length;
               
                     if(divLength == 0   )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_default').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_default').html());
                        $('.offer-container .offer-code').html('');
                      //  $('.offer-container .offer-price .current').html('$175');
                      //  $('.offer-container .offer-price .original').html('$1999.00');
                      
                       
                      }
                     if( divLength == 1  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_1').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_1').html());
                        $('.offer-container .offer-code').html('');
                       // $('.offer-container .offer-price .current').html('$175');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                      if(divLength == 2  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_2').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_2').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_2').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$175');
                        //$('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                       if(divLength == 3  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_3').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_3').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_3').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$318');
                       // $('.offer-container .offer-price .original').html('$3200.00');
                       
                      }
    if(divLength == 4  )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_4').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_4').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_4').html()+'</strong>');
                       // $('.offer-container .offer-price .current').html('$400');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                       
                      }
                if(buynow)
                {
                  location = "/checkout";
                }
                else
                {
                // console.log(minicartdata);
                $('#slidingcartmain').html(minicartdata);
                $("#size-error").hide();
                $('.header-cart-related-list').slick({
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                });
                $("#overlay").addClass("is-active");
                $(".inline-cart").addClass("is-active");
                /* changes - toggle hidden reward & chat widget */
                $("#admin-bar-iframe").css("display", "none");
                $("#chat-button").css("display", "none");
                }
              }
            })
           },
            error: function(xhr, status, error) {
                // Handle error
              //Error: Insufficient stock. Please reduce the quantity.
                let errorMessage = $('<div class="qty_error-message">Out of stock.</div>');
                
                // Insert the error message before the button
                errorMessage.insertBefore($thisbtn);
                
                // Remove the error message after 5 seconds
                setTimeout(function() {
                     $(".qty_error-message").remove();
                }, 5000);
            }
        })
    }
  })
  //   $('body').on('click', '.site-header__cart', function(e){

  //     e.preventDefault();
  //     $("#overlay").addClass("is-active");
  //     $(".inline-cart").addClass("is-active");
  //   })

  $('body').on('click', '.close-cart-img', function(e){
    e.preventDefault();
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    /* changes - toggle hidden reward & chat widget */
    $("#admin-bar-iframe").css("display", "block");
    $("#chat-button").css("display", "block");
  })

  $('body').on('click', '.continueshopping', function(e){
    
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    /* changes - toggle hidden reward & chat widget */
    $("#admin-bar-iframe").css("display", "block");
    $("#chat-button").css("display", "block");
  })

  $('body').on('click', '#overlay', function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    /* changes - toggle hidden reward & chat widget */
    $("#admin-bar-iframe").css("display", "block");
    $("#chat-button").css("display", "block");
  })

})

$(document).ready(function(){
  $('body').on('change', '.changequantity', function(){
    var getline = $(this).attr("data-line-item-index");
    var getval = $(this).val();

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + getval + '&line=' + getline,
      dataType: 'json',
      success: function(data){
        if(data.item_count > 0){
          $('.site-header__cart #CartCount').html(data.item_count);          
        } else {
          $('.site-header__cart #CartCount').html(data.item_count) ;         
        }

        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',
          success: function(data){
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $("#overlay").addClass("is-active");
            $(".inline-cart").addClass("is-active");
            /* changes - toggle hidden reward & chat widget */
            $("#admin-bar-iframe").css("display", "none");
            $("#chat-button").css("display", "none");
          }
        })
      }
    })

  })

})

$(document).on("click",".bundle-close",function(e){
  e.preventDefault();
  e.stopPropagation();
  $("#global-loading").addClass("active");
  var elem = $(this);
  elem.parent().slideUp(300,function(){
    group_id = elem.attr("data-id");
    kk = elem.attr("data-keys").split(",");
          uu = {};
          for(var i = 0; i < kk.length; i++)
          {
            uu[kk[i]] = 0;
          }
                        var attributes = {};
      attributes["group:" + group_id] = "";
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: uu, attributes: attributes },
        dataType: 'json',
        success:function(response){
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cartdata){
              $('.site-header__cart #CartCount').html(cartdata.item_count);
              $.ajax({
                type: "GET",
                url: "/cart",
                dataType: 'html',
                success: function(data) {
                  var countget=$(data).find('.cart_count_items').html();
                  var divLength =$(data).find('.cart_count_items').length;
                  $('.cart_count_items').html(countget);
                  if(divLength==0){
                    $('.cart_count_items').remove();
                  }
                  else{
                    $('.cart_count_items').show();
                  }
                  var minicartdata = $(data).filter('#slidingcartmain').html();
    
                  $('#slidingcartmain').html(minicartdata);
                  $('.header-cart-related-list').slick({
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  });
    
                }
              });
            }
          });
        }
      });
  });
});

function remove(line, quantity){
  $.ajax({
    type: 'POST',
    url: '/cart/change',
    data: 'quantity='+quantity+'&line='+line,
    dataType: 'json',
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata){
          $('.site-header__cart #CartCount').html(cartdata.item_count);
          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: 'html',
            success: function(data) {
              var countget=$(data).find('.cart_count_items').html();
              var divLength =$(data).find('.cart_count_items').length;
              console.log(divLength);
              $('.cart_count_items').html(countget);
              if(divLength==0){
                $('.cart_count_items').remove();
              }
              else{
                $('.cart_count_items').show();
              }
              var minicartdata = $(data).filter('#slidingcartmain').html();
             
                      if(divLength == 0   )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_default').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_default').html());
                        $('.offer-container .offer-code').html('');
                      //  $('.offer-container .offer-price .current').html('$175');
                      //  $('.offer-container .offer-price .original').html('$1999.00');
                      
                       
                      }
                     if( divLength == 1  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_1').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_1').html());
                        $('.offer-container .offer-code').html('');
                       // $('.offer-container .offer-price .current').html('$175');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                      if(divLength == 2  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_2').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_2').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_2').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$175');
                        //$('.offer-container .offer-price .original').html('$1999.00');
                        
                      }
                       if(divLength == 3  )
                      {
                         $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_3').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_3').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_3').html()+'</strong>');
                        //$('.offer-container .offer-price .current').html('$318');
                       // $('.offer-container .offer-price .original').html('$3200.00');
                       
                      }
    if(divLength == 4  )
                      {
                        $('.offer-container .offer-title').html($('#buy_now_offer_title_quantity_4').html());
                        $('.offer-container .offer-desc').html($('#buy_now_offer_desc_quantity_4').html());
                        $('.offer-container .offer-code').html('Use Code: <strong>'+$('#buy_now_offer_code_quatity_4').html()+'</strong>');
                       // $('.offer-container .offer-price .current').html('$400');
                       // $('.offer-container .offer-price .original').html('$1999.00');
                       
                      }
              $('#slidingcartmain').html(minicartdata);
              $('.header-cart-related-list').slick({
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
              });

            }
          });
        }
      });
    }
  });
}

$(document).ready(function(){
  $("img.closebar").click(function(){
    $(this).hide();
    $(this).siblings(".promotionaltext.lightboxdisplay").hide();
    $(".home-slideshow.content-width").addClass("pickup");
  })

  $("#AddToCart").click(function(e){
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:$(".product-single__meta .product-form").serialize(),
      dataType: 'json',
      success: function(response){
        saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('.site-header__cart #CartCount').html(cartdata.item_count);
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                var countget=$(data).find('.cart_count_items').html();
                $('.cart_count_items').html(countget);
                var minicartdata=$(data).filter('#slidingcartmain').html();
                $('#slidingcartmain').html(minicartdata);
                $("#overlay").addClass("is-active");
                $(".inline-cart").addClass("is-active");
                /* changes - toggle hidden reward & chat widget  */
                $("#admin-bar-iframe").css("display", "none");
                $("#chat-button").css("display", "none");
              }
            });
          }

        });
      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);

      }
    });
  });
  /*$(document).on('click','.product-form__cart-submit',function(){
    setTimeout(function () {

      $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                var countget=$(data).find('.cart_count_items').html();
                console.log(countget);
              }
            });
    }, 2000);
     
  });*/
})